export type AttendanceRecord = { checkedInAt: string | null; checkInMethod: string; duplicate: boolean; householdName: string; id: string; name: string; partySize: number; source: string; syncState: string; email?: string; mailingAddress?: string; followUpConsent?: boolean; phone?: string; relationship?: string };

export const MINIMAL_ATTENDANCE_EXPORT_COLUMNS = ["name", "householdName", "partySize"] as const;
export const EXPANDED_ATTENDANCE_EXPORT_COLUMNS = ["email", "phone", "mailingAddress", "relationship", "followUpConsent", "source", "checkedInAt"] as const;

export function filterAttendanceRecords(records: readonly AttendanceRecord[], query: string, filter: "all" | "needs_review" | "offline") {
  const normalized = query.trim().toLocaleLowerCase();
  return records.filter((record) => {
    if (filter === "needs_review" && !record.duplicate) return false;
    if (filter === "offline" && record.source !== "staff_offline" && record.syncState === "synced") return false;
    return !normalized || [record.name, record.householdName, record.email, record.phone, record.mailingAddress, record.relationship].some((value) => String(value ?? "").toLocaleLowerCase().includes(normalized));
  });
}

export function attendanceExportFileName(lovedOneName: string, eventTitle: string, expanded: boolean) {
  const safe = (value: string) => value.toLocaleLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 48) || "attendance";
  return `${safe(lovedOneName)}-${safe(eventTitle)}-${expanded ? "approved-expanded" : "attendance"}.csv`;
}

/** The fragment keeps the opaque correction bearer out of HTTP request logs. */
export function buildAttendanceReceiptLink(receiptToken: string, href = typeof window !== "undefined" ? window.location.href : "") {
  if (!href) return receiptToken;
  const url = new URL(href);
  url.hash = new URLSearchParams({ receipt: receiptToken }).toString();
  return url.toString();
}
